import EventService from './event-service';

export default EventService;
